import Flash from "../flash";
import ExceptionHandling from "../logging/exception_handling";

import $ from "jquery";

let globalAjaxInstalled = false;

export default function installGlobalAjaxComplete() {
  if (!globalAjaxInstalled) {
    globalAjaxInstalled = true;

    $(document).ajaxComplete((evt, xhr, ajaxOptions) => {
      const flashHeader = xhr.getResponseHeader("X-Flash");
      let flash;

      if (flashHeader) {
        try {
          flash = $.parseJSON(flashHeader);

          if (flash.error) {
            Flash.showError(flash.error);
          } else if (flash.notice) {
            Flash.showNotice(flash.notice);
          }
        } catch (ex) {
          ExceptionHandling.logError(`Could not parse X-Flash header. Error: ${ex.message}, header: ${flashHeader}`);
        }
      }
    });
  }
}
